// @ts-nocheck
import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActions,
  Container,
  Box,
  Grid,
  Paper,
  Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReceiptIcon from '@mui/icons-material/Receipt';

// Styled components for enhanced visuals
const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[10],
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: 40,
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
}));

const SectionHeader = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(4),
  background: theme.palette.mode === 'dark' ? '#424242' : theme.palette.primary.main,
  color: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
}));

const MeasureCanada: React.FC = () => {
  const theme = useTheme();

  // Data for Measure Canada forms
  const formsData = [
    {
      title: 'Transfer Notice',
      description: 'Complete this form for the transfer notice when replacing a device. This is required by Measurement Canada regulations.',
      icon: <AssignmentIcon />,
      url: 'https://www.ic.gc.ca/eic/site/mc-mc.nsf/frm-eng/MJAT-B2RHVD',
      buttonText: 'Open Form',
      buttonIcon: <OpenInNewIcon />
    },
    {
      title: 'Unsealed Device Form',
      description: 'Complete the IC3161E form when unsealing a device. This document must be submitted to Measurement Canada after service.',
      icon: <ReceiptIcon />,
      url: 'https://firebasestorage.googleapis.com/v0/b/uptime-tracker-2ba03.appspot.com/o/Documents%2FIC3161-eng.pdf?alt=media&token=591f1284-e0b6-4899-940a-6a918a3a6f9d',
      buttonText: 'Download Form',
      buttonIcon: <DownloadIcon />
    }
  ];

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" color="text.primary">
          Measure Canada Resources
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Access official forms and resources required for compliance with Measurement Canada regulations.
        </Typography>

        <SectionHeader elevation={2}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DescriptionIcon sx={{ mr: 2, fontSize: 28 }} />
            <Typography variant="h5">Official Forms</Typography>
          </Box>
        </SectionHeader>

        <Grid container spacing={3}>
          {formsData.map((form, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StyledCard elevation={3}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <IconWrapper>
                    {form.icon}
                    <Box>
                      <Typography variant="h6" component="div" fontWeight="medium">
                        {form.title}
                      </Typography>
                    </Box>
                  </IconWrapper>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {form.description}
                  </Typography>
                </CardContent>
                <Divider />
                <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={form.buttonIcon}
                    onClick={() => window.open(form.url)}
                    size="medium"
                  >
                    {form.buttonText}
                  </Button>
                </CardActions>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default MeasureCanada;